// eslint-disable-next-line
import {
  getUsersCustomer,
  deleteUser,
  getAllUsers,
} from '@/api/index';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state() {
    return ({
      users: [],
      userSelected: {},
      loadingUsers: false,
    });
  },
  getters: {

  },
  mutations: {
    setUsers(state, usersList) {
      state.users = usersList;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven();}, 10);
    },
    setUserSelected(state, user) {
      if (user) {
        state.userSelected = user;
      }
    },
    setLoading(state, status) {
      state.loadingUsers = status;
    },
  },
  actions: {
    async apiGetUsers({
      commit,
      state,
    }) {
      commit('setLoading', true);
      await getUsersCustomer(null).then((res) => {
        if (res.users) {
          commit('setUsers', res.users.filter((user) => !user.deleted));
          if (state.users.length) {
            commit('setUserSelected', state.users[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiGetAllUsers({
      commit,
      state,
    }) {
      commit('setLoading', true);
      await getAllUsers().then((res) => {
        if (res.users) {
          commit('setUsers', res.users.filter((user) => !user.deleted));
          if (state.users.length) {
            commit('setUserSelected', state.users[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiDeleteUser({
      commit,
      state,
    }) {
      await deleteUser(state.userSelected.user_id).then((res) => {
        commit('setUsers', state.users.filter((usr) => usr.user_id !== res.user_id));
        commit('setUserSelected', state.users[0]);
      });
    },

  },
};
